import React from 'react';
import PropTypes from 'prop-types';
import { FormLabel } from '../../components/style/export';
import PropertyStyle from './shared-property-style';
import { UNITS_LENGTH, UNIT_CENTIMETER, UNIT_MILLIMETER } from './../../constants';
import Translator from '../../translator/translator';

export default function PropertyReadOnly(_ref) {
  var value = _ref.value,
      onUpdate = _ref.onUpdate,
      configs = _ref.configs,
      sourceElement = _ref.sourceElement,
      internalState = _ref.internalState,
      state = _ref.state;

  var length = value.get('length') || 0;
  var _length = value.get('_length') || length;
  var _unit = value.get('unit') || UNIT_MILLIMETER;
  var translator = new Translator();

  return React.createElement(
    'table',
    { className: 'PropertyReadOnly', style: PropertyStyle.tableStyle },
    React.createElement(
      'tbody',
      null,
      React.createElement(
        'tr',
        null,
        React.createElement(
          'td',
          { style: PropertyStyle.firstTdStyle },
          React.createElement(
            FormLabel,
            null,
            translator.t(configs.label)
          )
        ),
        React.createElement(
          'td',
          null,
          React.createElement(
            'div',
            { style: { padding: '8px 0px', fontSize: 12 } },
            _length,
            ' ',
            _unit
          )
        ),
        React.createElement('td', null)
      )
    )
  );
}

PropertyReadOnly.propTypes = {
  value: PropTypes.any.isRequired,
  onUpdate: PropTypes.func.isRequired,
  configs: PropTypes.object.isRequired,
  sourceElement: PropTypes.object,
  internalState: PropTypes.object,
  state: PropTypes.object.isRequired
};